import axios, { AxiosInstance } from 'axios';
import log from '../services/LogService';

class MeasurementService {
  private measurementId: string;
  private client: AxiosInstance;

  constructor() {

    this.measurementId = '';

    this.client = axios.create({
      baseURL: process.env.API_URL,
    });

  }

  setSessionId(sessionId: string) {
    this.client.defaults.headers.common.Authorization = `Bearer ${sessionId}`;
  }

  setMeasurementId(measurementId: string) {
    this.measurementId = measurementId;
  }

  getMeasurementFrames() {
    const measurementId = this.measurementId;
    return this.client.get(`/measurements/${measurementId}/frames`);
  }

  createPiReconstruction(email:string) {
    const measurementId = this.measurementId;
    return this.client.post(
      `/measurements/${measurementId}/pi-reconstructions`, { email });
  }
}

export default new MeasurementService();
